import { Directive, OnInit, AfterViewInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Directive()
export abstract class LocalTable<T> implements OnInit, AfterViewInit {
	loading$ = new BehaviorSubject<boolean>(false);
	readonly destroyRef = inject(DestroyRef);
	tRows: T[] = [];
	total = 0;
	defaultPageSize = 25;

	pageSizeOptions = [25, 50, 100, 200];
	abstract filtersForm: FormGroup;

	ngOnInit(): void {
		this.reload();
	}

	ngAfterViewInit(): void {
		this.filtersForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef), debounceTime(200)).subscribe(() => {
			this.reload();
		});
	}

	abstract refresh(): void;
	abstract reload(): void;

	isFiltersApplied(): boolean {
		return Object.values(this.filtersForm.getRawValue()).some((value) => !!value);
	}

	incorrectPagination(): boolean {
		return this.total > 0 && this.tRows.length === 0;
	}
}
